import React from 'react';
import { Grid, Card, CardContent, Typography, Button, Divider, Box } from '@mui/material';
import Slider from 'react-slick';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
const cardData = [
  {
    id: 1,
    title: 'STYLE',
    subtitle: 'HECTOR STYLE ',
    // price: '₹14,00,000',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0004.webp?alt=media&token=7ab613e1-76ec-4191-a5f6-4a9ccc8d64e0",
    features: [
      '6 Airbags',
      'Tilt Steering',
      '2nd Row Seat Recline w/ 60:40 Split',
      'LED DRLs & Positioning Lamps​',
      'Turn Indicator On ORVM',
      'Leather Driver Armrest with Storage',
      'Rear Parking Sensors',
      'Hill Hold Control​',
      
    ],
  },
  {
    id: 2,
    title: 'SELECT PRO',
    subtitle: 'HECTOR SELECT PRO MT',
    // price: '₹16,17,000',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0002.webp?alt=media&token=4dea8393-fece-4e42-a138-d76e1df23651",
    features: [
      'iSWIPE Touch gesture controls',
      'Indias Largest 35.56 cm (14 inch) HD Screen Infotainment System',
      'Aura Hex Grille',
      'Wireless Android Auto + Apple Carplay',
      'Dual Pane Panoramic Sunroof',
      'Reverse Parking Camera',
      'Full Led Tail Lamps',
      'Full Digital Cluster with 17.78 cm Multi Information Display',
      

    ],
  },
  {
    id: 3,
    title: 'SMART PRO',
    subtitle: 'HECTOR SMART PRO MT',
    // price: '₹18,29,000',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0003.webp?alt=media&token=4ec1ca6e-a441-4e25-b0a6-afea9a0ffa85",
    features: [
      'i-SWIPE Touch gesture controls',
      'Indias Largest 35.56 cm (14inch) HD Screen Infotainment System',
      'Aura Hex Grille',
      'Wireless Android Auto + Apple Carplay​',
      'Dual Pane Panoramic Sunroof',

    ],
  },
  {
    id: 4,
    title: 'SMART PRO',
    subtitle: 'HECTOR SMART PRO CVT',
    // price: '₹16,89,000',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0004.webp?alt=media&token=7ab613e1-76ec-4191-a5f6-4a9ccc8d64e0",
    features: [
      'i-SWIPE Touch gesture controls',
      'Indias Largest 35.56 cm (14inch) HD Screen Infotainment System',
      'Aura Hex Grille',
      'Wireless Android Auto + Apple Carplay​',
      'Dual Pane Panoramic Sunroof',
      

    ],
  },
   {
    id: 5,
    title: 'SHARP PRO',
    subtitle: 'HECTOR SHARP PRO MT',
    // price: '₹19,69,000',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0002.webp?alt=media&token=4dea8393-fece-4e42-a138-d76e1df23651",
    features: [
      'i-SWIPE Touch gesture controls',
      'Indias Largest 35.56 cm (14inch) HD Screen Infotainment System',
      'Aura Hex Grille',
      'Wireless Android Auto + Apple Carplay',
      'Dual Pane Panoramic Sunroof',

    ],
  },
   {
    id: 6,
    title: 'SHARP PRO',
    subtitle: 'HECTOR SHARP PRO CVT ',
    // price: '₹19,69,000',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0004.webp?alt=media&token=7ab613e1-76ec-4191-a5f6-4a9ccc8d64e0",
    features: [
      'i-SWIPE Touch gesture controls',
      'Indias Largest 35.56 cm (14inch) HD Screen Infotainment System',
      'Aura Hex Grille',
      'Wireless Android Auto + Apple Carplay',
      'Dual Pane Panoramic Sunroof',
      

    ],
  },
  
  {
    id: 7,
    title: 'SAVVY PRO',
    subtitle: 'HECTOR SAVVY PRO CVT',
    // price: '₹20,76,000',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0004.webp?alt=media&token=7ab613e1-76ec-4191-a5f6-4a9ccc8d64e0",
    features: [
      'i-SWIPE Touch gesture controls',
      'Indias Largest 35.56 cm (14inch) HD Screen Infotainment System',
      'Aura Hex Grille',
      'Wireless Android Auto + Apple Carplay',
      'Dual Pane Panoramic Sunroof',
      'Front Ventilated Seats',
      'ADAS Level 2',
      
      
    ],
  },

{
    id: 8,
    title: 'SHARP PRO',
    subtitle: 'HECTOR SHARP PRO MT (7 SEATER)',
    // price: '₹19,99,000',
    image: 'https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0004.webp?alt=media&token=7ab613e1-76ec-4191-a5f6-4a9ccc8d64e0',
    features: [
      'i-SWIPE Touch gesture controls',
      'Indias Largest 35.56 cm (14inch) HD Screen Infotainment System',
      'Aura Hex Grille',
      'Wireless Android Auto + Apple Carplay',
      'Dual Pane Panoramic Sunroof',
      'Front Ventilated Seats',
      'Dual Tone Urban Tan interiors',

    ],
  },
  {
    id: 9,
    title: 'SHARP PRO',
    subtitle: 'HECTOR SHARP PRO CVT (7 SEATER)',
    // price: '₹18,34,000',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0004.webp?alt=media&token=7ab613e1-76ec-4191-a5f6-4a9ccc8d64e0",
    features: [
      'i-SWIPE Touch gesture controls',
      'India Largest 35.56 cm (14inch) HD Screen Infotainment System',
      'Aura Hex Grille',
      'Wireless Android Auto + Apple Carplay',
      'Dual Pane Panoramic Sunroof',
      'Front Ventilated Seats',
      'Dual Tone Urban Tan interiors',
      

    ],
  },
  {
    id: 10,
    title: 'SAVVY PRO',
    subtitle: 'HECTOR SAVVY PRO (7SEATER)',
    // price: '₹19,99,900',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-thm-img-0004.webp?alt=media&token=7ab613e1-76ec-4191-a5f6-4a9ccc8d64e0",
    features: [
      'i-SWIPE Touch gesture controls',
      'Indias Largest 35.56 cm (14inch) HD Screen Infotainment System',
      'Aura Hex Grille',
      'Wireless Android Auto + Apple Carplay',
      'Dual Pane Panoramic Sunroof',
      'Front Ventilated Seats',
      'ADAS Level 2',
    ],
  },

  
 
 
 
    
  
  


];



const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <ArrowForwardIos
      onClick={onClick}
      style={{
        color: 'black',
        fontSize: '30px',
        position: 'absolute',
        top: '50%',
        right: '10px',
        cursor: 'pointer',
        zIndex: 1
      }}
    />
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <ArrowBackIos
      onClick={onClick}
      style={{
        color: 'black',
        fontSize: '30px',
        position: 'absolute',
        top: '50%',
        left: '10px',
        cursor: 'pointer',
        zIndex: 1
      }}
    />
  );
};
// Carousel settings
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 960, // Tablet
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 600, // Mobile
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};


const CardGrid = () => {
  // Define card height
  const cardHeight = { md: '1200px', xs: '750px', sm: '1150px' };

  return (
    <Box sx={{
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Typography variant="h2"
        sx={{
          fontSize: { md: '2.08333vw', xs: '4.2vw' },
          color: '#cf2230',
          fontFamily: 'GillSansSemiBold, Arial, sans-serif',
          paddingBottom: '1.125vw',
          fontWeight: '600',
          marginTop: { md: '80px', xs: '40px', sm: '50px' },
          marginBottom: { xs: '10px' }
        }}>
        MG Hector Model Variants
      </Typography>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <Slider {...settings}>
            {cardData.map((card) => (
              <div key={card.id}>
                <Card
                  sx={{
                    height: cardHeight,
                    width: {
                      xs: '75%',  // For small screens
                      sm: '87%',  // For medium screens
                      md: '80%',  // For larger screens
                      lg: '70%'   // For very large screens
                    },
                    margin: '5px auto',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '16px',
                    boxSizing: 'border-box',
                    '@media (min-width: 1024px) and (max-width: 1139px)': {
                      width: '300px',
                    },
                  }}
                >
                  <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: 'GillSansRegular, sans-serif',
                        fontSize: { xs: '4vw', sm: '2.5vw', md: '2vw', lg: '1.27083vw' },
                        color: '#000',
                        marginBottom: '20px',
                      }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontFamily: 'Roboto-Regular, sans-serif',
                        fontSize: { xs: '3vw', sm: '1.6vw', md: '1.5vw', lg: '0.84167vw' },
                        color: '#6e6e6e',
                        marginBottom: { xs: '4vw', sm: '3vw', md: '2vw', lg: '1.0416vw' },
                      }}
                    >
                      {card.subtitle}
                    </Typography>
                    <Button
                      sx={{
                        display: 'inline-block',
                        backgroundColor: '#e1e1e1',
                        borderRadius: '5px',
                        textAlign: 'center',
                        padding: '8px 20px',
                        fontFamily: 'GillSansRegular, sans-serif',
                        fontSize: { xs: '4vw', sm: '2.1vw', md: '1.5vw', lg: '0.8167vw' },
                        color: '#000',
                        marginBottom: { xs: '2.1vw', sm: '2vw', md: '1vw', lg: '1.04167vw' },
                        '&:hover': { backgroundColor: '#d4d4d4' },
                      }}
                    >
                      Book Now
                    </Button>
                    <Typography
                      sx={{
                        fontFamily: 'Roboto-Regular, sans-serif',
                        fontSize: { xs: '5vw', sm: '2.6vw', md: '2vw', lg: '0.84167vw' },
                        color: '#6e6e6e',
                        marginBottom: { xs: '2vw', sm: '1.5vw', md: '1vw', lg: '.52083vw' },
                      }}
                    >
                      Starts From
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: 'Roboto-Medium, sans-serif',
                        fontSize: { xs: '5vw', sm: '4vw', md: '3vw', lg: '1.875vw' },
                        color: '#000',
                        marginBottom: 0,
                      }}
                    >
                      {card.price}
                    </Typography>
                    <img
                      src={card.image}
                      alt={card.subtitle}
                      className="car-image"
                      style={{ width: '100%',height:'30vh', objectFit: 'cover' }}
                      sx={{
                        height: { xs: '100px', md: '200px' }, // Adjust the height for different screen sizes
                      }}
                    />

                    <ul className="points" style={{ flexGrow: 1 }}>
                      {card.features.map((feature, index) => (
                        <li
                          key={index}
                          style={{
                            fontFamily: 'Roboto-Regular, sans-serif',
                            fontSize: '1.04167vw', // Default for larger screens
                            color: '#000',
                            marginBottom: '1.04167vw',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontWeight: '600',
                              fontSize: { xs: '10px', sm: '12px', md: '1.04167vw' }, // Responsive font sizes
                              '@media (max-width: 425px)': {
                                fontSize: '12px',
                              },
                            }}
                          >
                            {feature}
                          </Typography>
                        </li>
                      ))}
                    </ul>


                    <Divider style={{ color: '#D4D4D5' }} />
                    <Typography
                      sx={{
                        fontFamily: 'Roboto-Regular, sans-serif',
                        fontSize: { md: '.9375vw', xs: '10px' },
                        color: '#000',
                        marginTop: '40px',
                        position: 'absolute',
                        bottom: '30px',
                        width: '100%',
                        textAlign: 'center',
                      }}
                    >
                      Brochure
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            ))}
          </Slider>
        </Grid>
      </Grid>
      {/* <Button
        sx={{
          backgroundColor: '#CF2230',
          color: 'white',
          fontWeight: '700',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontFamily: 'GillSansSemiBold, sans-serif',
          fontSize: { md: '0.95vw', xs: '1.5vw' },
          marginBottom:'40px',
          cursor: 'pointer',
          marginTop: '50px',
          '&:hover': {
            backgroundColor: 'black',
            color: 'white',
          },
        }}
      >
        Compare Variants
      </Button> */}
    </Box>
  );
};

export default CardGrid;
